const SET_WEBHOOKS = "SET_WEBHOOKS";
const ADD_WEBHOOK = "ADD_WEBHOOK";
const UPDATE_WEBHOOK = "UPDATE_WEBHOOK";
const DELETE_WEBHOOK = "DELETE_WEBHOOK";

export { SET_WEBHOOKS, ADD_WEBHOOK, UPDATE_WEBHOOK, DELETE_WEBHOOK };
